// Keep the screen awake while recording or sending (Screen Wake Lock API, where supported).
// The browser drops the lock when the page is hidden; we take it again when it comes back.
import { logger } from '../lib/log.js';

const log = logger('recorder');
let sentinel = null;
let wanted = false;
let listening = false;

async function acquire() {
  if (!wanted || sentinel || !('wakeLock' in navigator) || document.visibilityState !== 'visible') return;
  try {
    sentinel = await navigator.wakeLock.request('screen');
    sentinel.addEventListener('release', () => { sentinel = null; });
  } catch (e) {
    sentinel = null;
    log.warn('wake_lock_failed', { errName: e && e.name });
  }
}

export function keepAwake(on) {
  wanted = !!on;
  if (!listening) {
    listening = true;
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') acquire(); });
  }
  if (wanted) acquire();
  else if (sentinel) { const s = sentinel; sentinel = null; s.release().catch(() => {}); }
}
